import api from "./axiosInstance";
import apiRoutes from "./api_route";

export const checklistDocumentUplodOptions = async (values) => {
  try {
    const result = await api.get(apiRoutes.settings.generalSettings);
    return values !== "" ? result.data : "";
  } catch (error) {
    return [];
  }
};
